// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

/* eslint-disable */

/**
 * This is a automatically generated component, do not edit it.
 * If you need to edit this component, move it to some other folder.
 */

import React from 'react';
function DrugIcon24(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <g
        fill="currentColor"
        clipPath="url(#a)"
      >
        <path d="M19.954 3.276a.333.333 0 0 0 .334-.333v-1.25a.333.333 0 0 0-.667 0v1.25a.333.333 0 0 0 .333.333ZM17.978 3.276a.333.333 0 0 0 .333-.333v-1.25a.333.333 0 1 0-.666 0v1.25a.333.333 0 0 0 .333.333ZM16 3.276a.334.334 0 0 0 .333-.333v-1.25a.333.333 0 1 0-.667 0v1.25a.333.333 0 0 0 .333.333ZM14.023 3.276a.333.333 0 0 0 .333-.333v-1.25a.333.333 0 1 0-.666 0v1.25a.333.333 0 0 0 .333.333ZM12.046 3.276a.333.333 0 0 0 .334-.333v-1.25a.333.333 0 0 0-.667 0v1.25a.333.333 0 0 0 .333.333ZM17.11 7h1.377a.333.333 0 1 0 0-.666h-1.376a.333.333 0 1 0 0 .667Z" />
        <path d="M23.874 9.417 20.73 6.51V4.637h.214a.96.96 0 0 0 .956-.97V.96a.96.96 0 0 0-.956-.96h-9.887a.96.96 0 0 0-.957.96v2.707a.96.96 0 0 0 .957.96h.213V6.5L8.127 9.407a3.084 3.084 0 0 0-1 2.26V28.92a3.087 3.087 0 0 0 3.09 3.08h11.567a3.087 3.087 0 0 0 3.08-3.08V11.667a3.082 3.082 0 0 0-.99-2.25Zm-13.107-5.75V.96a.288.288 0 0 1 .29-.293h9.887a.29.29 0 0 1 .29.293v2.707a.293.293 0 0 1-.29.293h-9.887a.293.293 0 0 1-.29-.293ZM8.58 9.907 11.734 7h2.89a.333.333 0 1 0 0-.667h-2.687V4.637h8.127v2.03a.334.334 0 0 0 .11.243l3.246 3a2.414 2.414 0 0 1 .777 1.757v1.066H7.804v-1.066a2.413 2.413 0 0 1 .776-1.76Zm15.617 16.76h-3.51V13.4h3.51v13.267ZM7.804 13.4H20.02v13.267H7.804V13.4Zm13.98 17.933H10.217a2.416 2.416 0 0 1-2.413-2.413v-1.587h16.393v1.6a2.416 2.416 0 0 1-2.413 2.4Z" />
        <path d="m16.043 16.15-.79-.627a.334.334 0 0 0-.5.103c-.58 1.09-1.087 1.91-1.087 3.4-1.41-.583-2.43-.373-3.56-.24a.333.333 0 0 0-.28.427l.297.963a5.163 5.163 0 0 0 5.543 3.614c1.074-.12 1.064-.104 1.16-.177.097-.073.097-.103.574-1a5.157 5.157 0 0 0-1.357-6.463ZM10.777 20l-.18-.584c.893-.103 1.863-.266 3.156.394.095.585.291 1.149.58 1.666l-1.296-.876a.334.334 0 1 0-.37.556l3 1.964a4.493 4.493 0 0 1-4.89-3.12Zm6 2.393-.747-3.527a.335.335 0 0 0-.513-.21.333.333 0 0 0-.14.344l.733 3.506a4.497 4.497 0 0 1-1.243-5.666l.286-.537.477.363a4.493 4.493 0 0 1 1.133 5.71l.013.017ZM21.62 26.16h1.644a.333.333 0 0 0 .333-.334v-6.86a.334.334 0 0 0-.333-.333H21.62a.334.334 0 0 0-.333.333v6.86a.333.333 0 0 0 .333.334Zm.334-6.86h.976v6.193h-.976v-6.194Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            d="M0 0h32v32H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default DrugIcon24;
